module.exports = __webpack_public_path__ + "img/guia02.6e93de2a.svg";